import api from '../lib/api';
import { SummaryResponse } from '../types';

export interface AnalyticsParams {
  from?: string;
  to?: string;
  /** Comma-separated id lists. */
  projectId?: string;
  userId?: string;
}

const BASE = '/api/v1/admin/analytics';

export const analyticsApi = {
  summary: (params?: AnalyticsParams, signal?: AbortSignal) =>
    api.get<SummaryResponse>(`${BASE}/summary`, { params, signal }),
};
